import { Link } from "react-router-dom";
import { Play, Lock, Star, BadgeCheck } from "lucide-react";
import { countryFlag, countryName, typeLabel, onImgError } from "@/lib/constants";

export default function ContentCard({ item, index = 0 }) {
  const premium = item.subscription_required;
  return (
    <Link to={`/movie/${item.id}`} data-testid={`content-card-${item.id}`}
      className="group relative block w-full rounded-xl overflow-hidden bg-[#1A1724] border border-white/5 hover:border-[#E50914]/40 transition-all duration-300 hover:scale-[1.03] hover:z-10 hover:shadow-2xl hover:shadow-[#E50914]/10">
      <div className="relative aspect-[2/3] overflow-hidden">
        <img src={item.thumbnail} alt={item.title} loading="lazy" onError={onImgError}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#08070B] via-[#08070B]/20 to-transparent" />

        <div className="absolute top-2 left-2 flex flex-wrap gap-1.5">
          <span className="badge-glass" title={countryName(item.country)}>
            <span>{countryFlag(item.country)}</span>
            <span className="hidden sm:inline">{countryName(item.country)}</span>
          </span>
        </div>
        <div className="absolute top-2 right-2">
          {premium ? (
            <span className="badge-glass !bg-[#D4AF37]/20 !border-[#D4AF37]/40 text-[#F5D97A]">
              <Lock className="w-3 h-3" /> Premium
            </span>
          ) : (
            <span className="badge-glass !bg-emerald-500/20 !border-emerald-400/40 text-emerald-300">Free</span>
          )}
        </div>

        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <span className="w-14 h-14 rounded-full bg-[#E50914]/90 flex items-center justify-center shadow-lg shadow-[#E50914]/40">
            <Play className="w-6 h-6 text-white fill-white ml-0.5" />
          </span>
        </div>
      </div>

      <div className="p-3">
        <div className="flex items-center gap-1.5 mb-1">
          <span className="text-[10px] uppercase tracking-widest text-[#D4AF37] font-semibold">{typeLabel(item.content_type)}</span>
          {item.rating > 0 && (
            <span className="ml-auto flex items-center gap-0.5 text-[11px] text-white/70">
              <Star className="w-3 h-3 fill-[#F59E0B] text-[#F59E0B]" /> {item.rating}
            </span>
          )}
        </div>
        <h3 className="font-display font-bold text-sm leading-tight truncate">{item.title}</h3>
        <div className="flex items-center gap-1.5 mt-1.5">
          <span className="badge-glass !py-0.5 !text-[10px]">{item.language}</span>
          {item.creator?.verified && (
            <span className="flex items-center gap-0.5 text-[10px] text-white/50 truncate">
              <BadgeCheck className="w-3 h-3 text-[#E50914]" /> {item.creator_name}
            </span>
          )}
        </div>
      </div>
    </Link>
  );
}
